import React from 'react';
import { formatJson } from './helpers/cellFormatters';

const Hash = ({ params }) => {
    const value = params?.value;

    if (value === null) {
        return <></>;
    }

    return (
        <div>
            <pre>{formatJson(value)}</pre>
        </div>
    );
};

export default Hash;
